import { render } from "./ReserveConfirm.vue?vue&type=template&id=5de6a2a2&scoped=true"
import script from "./ReserveConfirm.vue?vue&type=script&lang=js"
export * from "./ReserveConfirm.vue?vue&type=script&lang=js"

import "./ReserveConfirm.vue?vue&type=style&index=0&id=5de6a2a2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de6a2a2"]])

export default __exports__